const Projects = () => {
  return (
    <section className="projects">
      <h3>Projects</h3>
    </section>
  )
}

export default Projects
